import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import bus from '@/utils/bus';
import '@/utils/bootstrap';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  bus,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js